const macroPhaseColors = [
  'primary',
  'success',
  'warning',
  'accent',
  'secondary',
] as const;

export type LifecycleMacroPhaseColor = (typeof macroPhaseColors)[number];

export function getLifecycleMacroPhaseColor(
  index: number,
): LifecycleMacroPhaseColor {
  return macroPhaseColors[index % macroPhaseColors.length] ?? 'secondary';
}
